import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=45f4122f"
import script from "./UserFilter.vue?vue&type=script&lang=ts"
export * from "./UserFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports